import React from 'react';

import classes from './AddonsContent.scss';

const addonsContent = (props) => {

    let contentClass = [classes.Content];

    if (props.type === 'insurance') {
        contentClass.push(classes.ContentInsurance);
    }

    if(props.type === 'gst') {
        contentClass.push(classes.ContentGST);
    }
    
    return (
        <main className={contentClass.join(' ')}>
            {props.children}   
        </main>
    );
}

export default addonsContent;


// WEBPACK FOOTER //
// ./src/components/UI/Contents/AddonsContent/AddonsContent.js